import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { LayoutGrid, Select, TextField, Button } from '@archer-technologies/ui-components';
import { useRef, useState, useEffect, createElement, Fragment } from 'react';
import { isFilterValueEmpty } from './helpers.js';

var useNumberColumnFilterRefs = function useNumberColumnFilterRefs() {
  var selectHandleClickAwayOverride = useRef(false);
  return {
    handleClickAwayOverrideRefs: {
      selectHandleClickAwayOverride: selectHandleClickAwayOverride
    }
  };
};

var keyListeners = {
  enter: 'Enter'
};

var NumberColumnFilter = function NumberColumnFilter(_ref) {
  var filter = _ref.filter,
      columnName = _ref.columnName,
      columnFilterOperations = _ref.columnFilterOperations,
      selectedFilterOperation = _ref.selectedFilterOperation,
      onFilter = _ref.onFilter,
      addClearFilterStateFn = _ref.addClearFilterStateFn,
      removeClearFilterStateFn = _ref.removeClearFilterStateFn,
      messages = _ref.messages,
      classNames = _ref.classNames,
      _ref$filterComponentR = _ref.filterComponentRefs,
      filterComponentRefs = _ref$filterComponentR === void 0 ? {} : _ref$filterComponentR;

  var _React$useState = useState(filter ? String(filter.value) : ''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      newFilterValue = _React$useState2[0],
      setNewFilterValue = _React$useState2[1];

  var _React$useState3 = useState(selectedFilterOperation),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      newFilterOperation = _React$useState4[0],
      setNewFilterOperation = _React$useState4[1];

  var clearButtonDisabled = !newFilterValue;
  var applyButtonDisabled = !newFilterValue;

  if (filter) {
    applyButtonDisabled = String(filter.value) === newFilterValue && selectedFilterOperation === newFilterOperation;
  }

  var onFilterClear = function onFilterClear() {
    setNewFilterValue('');
    onFilter(null);
    document.body.click();
  };

  var onFilterApply = function onFilterApply() {
    onFilter(!isFilterValueEmpty(newFilterValue) ? {
      value: Number(newFilterValue),
      operation: newFilterOperation
    } : null);
    document.body.click();
  };

  var setSelectHandleClickAwayOverride = function setSelectHandleClickAwayOverride(override) {
    var _filterComponentRefs$ = filterComponentRefs.handleClickAwayOverrideRefs,
        handleClickAwayOverrideRefs = _filterComponentRefs$ === void 0 ? {} : _filterComponentRefs$;

    if (handleClickAwayOverrideRefs.selectHandleClickAwayOverride) {
      var typedOverrideRef = handleClickAwayOverrideRefs.selectHandleClickAwayOverride;
      typedOverrideRef.current = override;
    }
  };

  var operationSelectProps = {
    options: columnFilterOperations.map(function (operation) {
      return {
        name: messages[operation],
        id: operation
      };
    }),
    value: newFilterOperation,
    onChange: function onChange(event) {
      return setNewFilterOperation(event.target.value);
    },
    onOpen: function onOpen() {
      return setSelectHandleClickAwayOverride(true);
    },
    onClose: function onClose() {
      return setSelectHandleClickAwayOverride(false);
    },
    margin: 'dense',
    inputLabel: messages.columnFilterLabel,
    showLabel: false
  };

  var handleTextFieldKeyDown = function handleTextFieldKeyDown(event) {
    if (event.key === keyListeners.enter && !applyButtonDisabled) {
      onFilterApply();
    }
  };

  var textFieldProps = {
    type: 'number',
    autoFocus: true,
    value: newFilterValue,
    onChange: function onChange(event) {
      return setNewFilterValue(event.target.value);
    },
    onKeyDown: handleTextFieldKeyDown,
    margin: 'dense',
    label: messages.columnFilterLabel
  };
  useEffect(function () {
    var clearFilterState = function clearFilterState() {
      return setNewFilterValue('');
    };

    addClearFilterStateFn(columnName, clearFilterState);
    return function () {
      return removeClearFilterStateFn(columnName);
    };
  }, [addClearFilterStateFn, removeClearFilterStateFn, columnName, setNewFilterValue]);
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(LayoutGrid, {
    container: true,
    justify: "space-between",
    className: classNames.mainContainer
  }, /*#__PURE__*/createElement(LayoutGrid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/createElement(Select, operationSelectProps)), /*#__PURE__*/createElement(LayoutGrid, {
    item: true,
    xs: 7
  }, /*#__PURE__*/createElement(TextField, textFieldProps))), /*#__PURE__*/createElement(LayoutGrid, {
    container: true,
    justify: "flex-end"
  }, /*#__PURE__*/createElement(LayoutGrid, {
    item: true
  }, /*#__PURE__*/createElement(Button, {
    color: "primary",
    variant: "text",
    size: "small",
    disabled: clearButtonDisabled,
    onClick: onFilterClear
  }, messages.clear)), /*#__PURE__*/createElement(LayoutGrid, {
    item: true
  }, /*#__PURE__*/createElement(Button, {
    color: "primary",
    size: "small",
    disabled: applyButtonDisabled,
    onClick: onFilterApply
  }, messages.apply))));
};

export { NumberColumnFilter, useNumberColumnFilterRefs };